export default "__VITE_PUBLIC_ASSET__1acd734a__"